<template>
  <div class="action_box">
    <a-dropdown :trigger="['click', 'hover']">
      <div class="header__avatar">
        <a-avatar size="small">
          <template #icon>
            <UserOutlined />
          </template>
        </a-avatar>
        <div class="header__avatar-name">
          {{ name.length > 0 ? name : "admin" }}
        </div>
      </div>
      <template #overlay>
        <a-menu>
          <!-- <a-menu-item key="4" @click="viewApiLog">
            {{ $t("last5Requests") }}
          </a-menu-item> -->
          <a-menu-item key="3" v-if="!isMobile">
            <span
              >{{ $t("hideNavigationBar") }}
              <a-switch v-model:checked="isShowMenu" @change="handleSwitchChange"
            /></span>
          </a-menu-item>
          <a-menu-item key="2" @click="clearCache"> {{ $t("clearCache") }} </a-menu-item>
          <a-menu-item key="1" @click="logout()"> {{ $t("logout") }} </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <QuestionFeedbackModal ref="ruestionFeedbackModalRef"></QuestionFeedbackModal>
  </div>
</template>
<script lang="ts">
import { mapState, useStore } from "vuex";
// import aIcon from "@/components/aicon/aicon.vue";
import { defineComponent, watch, computed, onBeforeMount, ref } from "vue";
import { RouterObj, RouterTable } from "@/types/api/login";
import { UserOutlined } from "@ant-design/icons-vue";
import { clearStorage } from "@/utils/common";
import QuestionFeedbackModal from "@/components/QuestionFeedbackModal.vue";
export default defineComponent({
  name: "HeaderAction",
  components: {
    UserOutlined,
    QuestionFeedbackModal,
  },
  computed: {
    ...mapState({
      name: (state: any) => state.user.nick,
      avatar: (state: any) => state.user.headImageUrl,
      routers: (state: any) => {
        const array: any[] = [];
        state.user.routers.forEach((item: any) => {
          if (!item.hidden) array.push(item);
        });
        return array;
      },
      isShowMenu: (state: any) => state.user.isShowMenu,
    }),
  },
  emits: ["update:collapsed"],
  props: {
    collapsed: {
      required: true,
      type: Boolean,
    },
  },
  setup() {
    const store = useStore();

    const activeKey = computed(() => store.state.menu.menuId);
    const ruestionFeedbackModalRef = ref();
    // 退出登录
    const logout = () => {
      store.dispatch("user/logout");
    };

    // 清除缓存
    const clearCache = () => {
      // localStorage.clear();
      clearStorage();
      sessionStorage.clear();
      logout();
    };
    function viewApiLog() {
      ruestionFeedbackModalRef.value.openModal();
    }
    // 切换tab
    const tabClick = (e: number) => {
      const routers = store.state.user.routers;
      let menuRouter: RouterTable = [];
      routers.forEach((item: RouterObj) => {
        if (item.id === e) {
          menuRouter = item.children || [];
        }
      });
      store.commit("menu/setMenu", menuRouter);
      store.commit("menu/setId", e);
    };

    watch(activeKey, () => {
      tabClick(activeKey.value);
    });

    onBeforeMount(() => {
      tabClick(activeKey.value);
    });

    function isMobileFn() {
      return /Android|iPhone|iPad|iPod|iOS|Windows Phone|Mobile/i.test(navigator.userAgent);
    }

    const isMobile = isMobileFn();
    if (isMobile) {
      store.state.user.isShowMenu = false
      localStorage.setItem("index_nav_hide_switch", JSON.stringify(false));
    }

    function handleSwitchChange(checked: boolean) {
      store.state.user.isShowMenu = checked;
      localStorage.setItem("index_nav_hide_switch", JSON.stringify(checked));
    }

    return {
      logout,
      isMobile,
      clearCache,
      tabClick,
      activeKey,
      handleSwitchChange,
      viewApiLog,
      ruestionFeedbackModalRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.action_box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 40px;
  margin-left: 10px;

  .header__avatar {
    position: relative;
    display: flex;
    align-items: center;
    line-height: 40px;

    .header__avatar-name {
      margin-left: 10px;
      color: #fff;
    }
  }
}
</style>
